
import RequestDeleteAgent from "components/ManageAgent/RequestDeleteList";
import Main from "layouts/Main";


function RequestDeletePage () {

  return (
    <>
    <Main namePage="รายการคำขอลบผู้ใช้">
      <div className="layout-content">
        <RequestDeleteAgent />
      </div>
    </Main>
    </>

  );
}

export default RequestDeletePage;